/**
 * Helper
 */
var helper = require('../../helper');
var swal = require('sweetalert2');

$(function() {
    var $datatable = $('#datatable-guardian-history'),
        guardianId = $datatable.data('guardian'),
        $showActions = $('.js-show-actions'),
        columns = [
            {data: 'id', name: 'id', visible: false, searchable: false},
            {data: 'property_name', name: 'room.property.name'},
            {data: 'property_id', name: 'room.property.property_id'},
            {data: 'property_postcode', name: 'room.property.postcode'},
            {data: 'room_name', name: 'room.name'},
            {data: 'date_start', name: 'date_start'},
            {data: 'date_end', name: 'date_end'},
	        {data: 'guardian_officer', name: 'guardian_officer'},
            {data: 'status', name: 'status', orderable: false, searchable: false},
            {data: 'licenses', name: 'licenses', orderable: false, searchable: false},
        ],
        actionColumn =  { data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" };

    if($showActions.length > 0){
        columns.push(actionColumn);
    }

    $datatable.DataTable({
        "dom": "<'dt-toolbar dt-toolbar-no-buttons'lf>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [ 30, 10, 25, 50, 75, 100],
        "ajax": helper.getOrigin() + "/api/rents/of-guardian/"+guardianId,
        "bAutoWidth" : false,
        "order": [[ 0, "desc" ]],
        "columns": columns
    });

    $datatable.on('click', '.rent-action', function (e) {
        e.preventDefault();
        var action = $('.rent-action').data('action');
        var link = $(this);

        var a = swal({
            title: "Are you sure you want to " + action + " rent?",
            text: "",
            type: "warning",
            showCancelButton: true,
            showConfirmButton: true,
        }).then(result => {
            if (result.value) {
                window.location = link.attr('href');
            }
        });
    })

});
